// Dubletten und Zusammenführen (Runde 7, Agent 7C): Typen und Client nach crm/API.md, Abschnitt 22.3.
import { http } from "./client";

export type DublettenArt = "alle" | "name" | "telefon" | "email" | "domain";

export interface DubletteLead {
  id: string;
  name: string | null;
  status_label: string | null;
  date_created: string | null;
  kontakte: number;
  aktivitaeten: number;
  offene_aufgaben: number;
  /** Lead mit Kundenakte im Backoffice: darf nicht gelöscht werden */
  hat_kundenakte?: boolean;
  ort?: string | null;
  telefon?: string | null;
  email?: string | null;
  url?: string | null;
  date_updated?: string | null;
  /** nur beim Hinweis zu einem Lead: warum der Lead als Dublette gilt */
  gruende?: { art: Exclude<DublettenArt, "alle">; wert: string }[];
}

export interface DublettenGruppe {
  /** gleicher Wert, der die Gruppe bildet (Name, Nummer, Adresse, Domain) */
  wert: string;
  art: Exclude<DublettenArt, "alle">;
  leads: DubletteLead[];
  /** so viele Leads gehören noch zur Gruppe, werden aber nicht gezeigt */
  weitere?: number;
  /** nur ein kurzer Name aus einem Wort: oft Zufall */
  schwach?: boolean;
  ganz_ignoriert?: boolean;
  /** gemerkte Paare "keine Dublette" innerhalb der gezeigten Leads */
  ignoriert?: [string, string][];
}

export interface DublettenSeite {
  data: DublettenGruppe[];
  has_more: boolean;
  cursor: string | null;
  total: number;
}

export interface ZusammenfuehrenVorschau {
  ziel: DubletteLead;
  quelle: DubletteLead;
  /** was vom Quell-Lead in den Ziel-Lead wandert */
  wandert: { kontakte: number; aktivitaeten: number; aufgaben: number; opportunities: number; dateien: number };
  felder: { feld: string; ziel: unknown; quelle: unknown; uebernommen: boolean }[];
  hinweise: string[];
  /** beide Leads haben eine Kundenakte: das CRM führt sie nicht zusammen */
  blockiert?: boolean;
}

export interface Zusammenfuehrung {
  id: number;
  ziel_lead_id: string;
  quelle_lead_id: string;
  ziel_name?: string | null;
  quelle_name?: string | null;
  user_id: string | null;
  user_name?: string | null;
  ts: string;
  quelle: "crm" | "close";
  umfang: Record<string, unknown>;
  rueckgaengig_at?: string | null;
  kann_rueckgaengig?: boolean;
}

export interface ZusammenfuehrenErgebnis {
  ziel_lead_id: string;
  quelle_lead_id?: string;
  umfang: Record<string, unknown>;
  /** Zeile im Protokoll, nötig fürs Rückgängigmachen */
  protokoll_id?: number;
}

const k = encodeURIComponent;

export const dublettenApi = {
  gruppen: (p: { art?: DublettenArt; ignorierte?: boolean; cursor?: string | null; limit?: number } = {}) => http.get<DublettenSeite>("/api/dubletten", p),
  zuLead: (leadId: string) => http.get<{ data: DubletteLead[] }>(`/api/dubletten/lead/${k(leadId)}`),
  vorschau: (zielLeadId: string, quelleLeadId: string) =>
    http.get<ZusammenfuehrenVorschau>("/api/dubletten/vorschau", { ziel_lead_id: zielLeadId, quelle_lead_id: quelleLeadId }),
  zusammenfuehren: (zielLeadId: string, quelleLeadId: string) =>
    http.post<ZusammenfuehrenErgebnis>("/api/dubletten/zusammenfuehren", { ziel_lead_id: zielLeadId, quelle_lead_id: quelleLeadId }),
  protokoll: (p: { cursor?: string | null; limit?: number } = {}) =>
    http.get<{ data: Zusammenfuehrung[]; has_more: boolean; cursor: string | null; total: number }>("/api/dubletten/protokoll", p),
  rueckgaengig: (protokollId: number) => http.post<{ ok: boolean; ziel_lead_id: string; quelle_lead_id: string }>(`/api/dubletten/protokoll/${protokollId}/rueckgaengig`),
  ignorieren: (leadA: string, leadB: string) => http.post<void>("/api/dubletten/ignorieren", { lead_a: leadA, lead_b: leadB }),
  ignorierenAufheben: (leadA: string, leadB: string) => http.del<void>(`/api/dubletten/ignorieren/${k(leadA)}/${k(leadB)}`),
};
